import { Box, Button, Typography } from "@mui/material";
import ProfileSidebar from "./profileSidebar";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import Universities from "./section/universities";
import Personal from "./section/personal";
import Documents from "./section/documents";
import TestScores from "./section/testScores";
import Preference from "./section/preference";
import Recommendations from "./section/recommendations";
import { ArrowBack } from "@mui/icons-material";
import { getStudentDetails } from "../../services";
import { useEffect, useState } from "react";
import AppliedUnivers from "./section/appliedUnivers";
import Education from "./section/education";
import WorkExperiences from "./section/workExperiences";
import Extracurricular from "./section/extracurricular";
import Family from "./section/family";
import { useAppDispatch } from "../../assets/hooks";
import { initRecommended } from "../../store/slices/recommendations";
import Cart from "./section/cart";
import SuggestedPackages from "./section/suggestedPackages";
import { initSuggestedPackage } from "../../store/slices/suggestedPackagesSlice";
import { SuggestedPackage } from "../../types/types";

interface ProfileProps {
  data?: {
    activity?: {
      products?: any[]; 
      wishList?: any[];
      cart:any[]
    };

    recommendations: {
      data:any[],
      criteria:any
    };
    education:any;
    workExperience:any;
    extraCurriculumActivities:any;
    preference:any;
    skills:string[];
    familyDetails:any,
    documents?: any,
    suggestedPackages:SuggestedPackage[],
    _id:string;
    tests:any[]
  };
}
export const DashboardRoutes = (props:ProfileProps) => {
  const { data } = props;
  return (
    <Routes>
      <Route path="applied" element={<AppliedUnivers data={data?.activity?.products}/>}  />
      <Route path="universities" element={<Universities data={data?.activity?.wishList}/>} />
      <Route path="personal" element={<Personal data={data}/>} />
      <Route path="documents" element={<Documents data={data?.documents} />} />
      <Route path="recommendation" element={<Recommendations  />} />
      <Route path="Education" element={<Education data={data?.education}/>} />
      <Route path="scores" element={<TestScores data={data?.tests}/>} />
      <Route path="experience" element={<WorkExperiences  data={data?.workExperience}/>} />
      <Route path="activities" element={<Extracurricular data={data?.extraCurriculumActivities}/>} />
      <Route path="preferences" element={<Preference data={data?.preference} skills={data?.skills}/>} />
      <Route path="family" element={<Family data={data?.familyDetails} />} />
      <Route path="cart" element={<Cart data={data?.activity?.cart} />} />
      <Route path="suggestedPackages" element={<SuggestedPackages data={data?.suggestedPackages} id={data?._id}/>} />
    </Routes>
  );
};

const ProfileLayout = () => {
  const navigate = useNavigate();
  const {id}:any = useParams();
  const [studentData, setStudentData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
 const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("_auth_token");
      if (!token) {
        localStorage.clear();
        navigate("/");
      }
      try {
        setLoading(true);
        const response = await getStudentDetails(id)
        if(response){
          setStudentData(response.data);
         dispatch(
          initRecommended({
            requestStatus: "initiated",
            responseStatus: "recieved",
            haveAnIssue: false,
            issue: "",
            data: response.data?.recommendations.data,
          })
        );
        dispatch(
          initSuggestedPackage({
            requestStatus: "initiated",
            responseStatus: "recieved",
            haveAnIssue: false,
            issue: "",
            data: response.data?.suggestedPackages,
          }));
        setLoading(false);

        }
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <Box>
      {/* Sidebar */}
      <Box
        sx={{
          background: "#3B3F76",
          padding: "8px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
          <Button
            onClick={() => navigate("/dashboard")}
            sx={{
              color: "#FBE3C8",
              borderRadius: 0,
              textTransform: "none",
              fontSize: "1rem",
            }}
          >
            <ArrowBack sx={{ color: "#FBE3C8" }} />
            Previous page
          </Button>
        </Box>
      </Box>
      {loading ? <Typography textAlign="center">Loading ...</Typography> : 
      <Box sx={{ display: "flex" }}>
        <Box component="nav" sx={{background:"#FCF1EE"}}>
          <ProfileSidebar data={studentData}/>
        </Box>
        {/* Main content */}
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 3,  }}
        >
          <DashboardRoutes data={studentData}/>
        </Box>
      </Box>
}
    </Box>
  );
};

export default ProfileLayout;
